import React from "react";

const PrintableK = ({ data }) => {
    const handlePrint = () => {
        // Create a new window or iframe to print
        const printWindow = window.open('', '_blank', 'width=600,height=600');

        // Prepare the content
        const content = `
            <div class="container" style="font-size: 14px; font-family: Arial; position: relative;">
                <div style="position: absolute; top: 27px; left: 243px;">${data.date1}</div>
                <div style="position: absolute; top: 12px; left: 370px;">${data.city}</div>
                <div style="position: absolute; top: 27px; left: 370px;">${data.date2}</div>
                <div style="position: absolute; top: 65px; left: 293px;">${localStorage.getItem("banqueAccountRIB")}</div>
                <div style="position: absolute; top: 65px; left: 533px; white-space: nowrap;"># ${data.amount} #</div>
                <div style="position: absolute; top: 118px; left: 533px; white-space: nowrap;"># ${data.amount} #</div>
                <div style="position: absolute; top: 115px; left: 60px; max-width: 150px; font-size: 12px; line-height: 1.2;">
  ${data.message1}
</div>

<div style="position: absolute; top: 125px; left: 220px; max-width: 150px; font-size: 12px; line-height: 1.2;">
  ${data.message2}
</div>
              
                <div style="position: absolute; top: 140px; left: 150px;">${data.amountWords}</div>
                <div style="position: absolute; top: 180px; left: 70px;">${data.city}</div>
                <div style="position: absolute; top: 180px; left: 153px;">${data.date2}</div>
                <div style="position: absolute; top: 180px; left: 253px;">${data.date1}</div>
                <div style="position: absolute; top: 220px; left: 90px;">${localStorage.getItem("banqueAccountRIB")}</div>
                <div style="position: absolute; top: 273px; left: 200px; max-width: 150px;">${data.testMessage}</div>
                <div style="position: absolute; top: 220px; left: 523px; max-width: 200px;">${localStorage.getItem("banqueAccountName")}</div>
            </div>
            <style>
                @media print {
                    .no-print {
                        display: none !important;
                    }
                }
            </style>
        `;

        // Write the content to the print window and print it
        printWindow.document.open();
        printWindow.document.write(content);
        printWindow.document.close();
        printWindow.print();
    };

    return (
        <div>
            <button
                onClick={handlePrint}
                style={{
                    marginBottom: "20px",
                    display: "block",
                }}
                className="btn btn-dark m-1 float-right no-print"
            >
                Imprimer
            </button>
        </div>
    );
};

export default PrintableK;
